import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"
import _imports_0 from '@/assets/images/partner-1.png'
import _imports_1 from '@/assets/images/partner-2.png'
import _imports_2 from '@/assets/images/partner-3.png'
import _imports_3 from '@/assets/images/partner-4.png'
import _imports_4 from '@/assets/images/partner-5.png'
import _imports_5 from '@/assets/images/partner-6.png'


const _hoisted_1 = { class: "partner-area pb-75" }
const _hoisted_2 = { class: "container mw-1356" }
const _hoisted_3 = { class: "row justify-content-center" }
const _hoisted_4 = {
  class: "col-xxl-2 col-sm-6 col-md-4",
  "data-aos": "fade-up",
  "data-aos-duration": "1000",
  "data-aos-delay": "100"
}
const _hoisted_5 = {
  class: "col-xxl-2 col-sm-6 col-md-4",
  "data-aos": "fade-up",
  "data-aos-duration": "1000",
  "data-aos-delay": "200"
}
const _hoisted_6 = {
  class: "col-xxl-2 col-sm-6 col-md-4",
  "data-aos": "fade-up",
  "data-aos-duration": "1000",
  "data-aos-delay": "300"
}
const _hoisted_7 = {
  class: "col-xxl-2 col-sm-6 col-md-4",
  "data-aos": "fade-up",
  "data-aos-duration": "1000",
  "data-aos-delay": "400"
}
const _hoisted_8 = {
  class: "col-xxl-2 col-sm-6 col-md-4",
  "data-aos": "fade-up",
  "data-aos-duration": "1000",
  "data-aos-delay": "500"
}
const _hoisted_9 = {
  class: "col-xxl-2 col-sm-6 col-md-4",
  "data-aos": "fade-up",
  "data-aos-duration": "1000",
  "data-aos-delay": "600"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_RouterLink = _resolveComponent("RouterLink")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _createElementVNode("div", _hoisted_4, [
          _createVNode(_component_RouterLink, { to: "/about-us" }, {
            default: _withCtx(() => [...(_cache[0] || (_cache[0] = [
              _createElementVNode("img", {
                src: _imports_0,
                alt: "شريكنا"
              }, null, -1)
            ]))]),
            _: 1
          })
        ]),
        _createElementVNode("div", _hoisted_5, [
          _createVNode(_component_RouterLink, { to: "/about-us" }, {
            default: _withCtx(() => [...(_cache[1] || (_cache[1] = [
              _createElementVNode("img", {
                src: _imports_1,
                alt: "شريكنا"
              }, null, -1)
            ]))]),
            _: 1
          })
        ]),
        _createElementVNode("div", _hoisted_6, [
          _createVNode(_component_RouterLink, { to: "/about-us" }, {
            default: _withCtx(() => [...(_cache[2] || (_cache[2] = [
              _createElementVNode("img", {
                src: _imports_2,
                alt: "شريكنا"
              }, null, -1)
            ]))]),
            _: 1
          })
        ]),
        _createElementVNode("div", _hoisted_7, [
          _createVNode(_component_RouterLink, { to: "/about-us" }, {
            default: _withCtx(() => [...(_cache[3] || (_cache[3] = [
              _createElementVNode("img", {
                src: _imports_3,
                alt: "شريكنا"
              }, null, -1)
            ]))]),
            _: 1
          })
        ]),
        _createElementVNode("div", _hoisted_8, [
          _createVNode(_component_RouterLink, { to: "/about-us" }, {
            default: _withCtx(() => [...(_cache[4] || (_cache[4] = [
              _createElementVNode("img", {
                src: _imports_4,
                alt: "شريكنا"
              }, null, -1)
            ]))]),
            _: 1
          })
        ]),
        _createElementVNode("div", _hoisted_9, [
          _createVNode(_component_RouterLink, { to: "/about-us" }, {
            default: _withCtx(() => [...(_cache[5] || (_cache[5] = [
              _createElementVNode("img", {
                src: _imports_5,
                alt: "شريكنا"
              }, null, -1)
            ]))]),
            _: 1
          })
        ])
      ])
    ])
  ]))
}